import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';

// With real Google/Facebook OAuth, the backend performs the entire code
// exchange server-side and sets the session cookie itself before
// redirecting here - the frontend never receives or handles a token. This
// route only exists to show a brief "signing you in" transition and to
// surface an error toast if the backend redirected with ?status=error.
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.search);
    const status = params.get('status');
    const message = params.get('message');

    if (status === 'error') {
      toast.error(message || 'Sign-in failed. Please try again.');
      navigate('/login', { replace: true });
      return;
    }

    // The session cookie is already set by the backend at this point.
    toast.success('Signed in successfully!');
    navigate('/products', { replace: true });
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
